<div class="flex flex-row items-center text-nowrap w-full overflow-hidden mb-1" [ngClass]="pastDay ? 'text-gray-600' : 'text-brand'">
  <div class="flex w-[6px] h-[6px] mr-2 rounded-full bg-brand-bright-orange"></div>
  <p class="w-full h-full overflow-hidden overflow-ellipsis p-0 m-0">
    <span class="font-semibold">{{item?.id}}</span>
    {{item?.name}}
  </p>
</div>
